module.exports = __webpack_public_path__ + "h5/img/you.5efd8e07.png";